<div class="content">
  <div class="texts">
    <h2>Cozy Elegance</h2>
    <h3>Wrap Yourself in Style with Our Chic Knitwear Collection</h3>
    <!-- <a matRipple>Shop Now</a> -->
    <a matButton="filled" [routerLink]="['/collection',collectionNo]"
      >Shop Now</a
    >
  </div>
  <div class="products">
    <img src="/images/home/sweater/product1.webp" alt="product" />
    <img src="/images/home/sweater/product2.webp" alt="product" />
  </div>
</div>
